import styled from "@emotion/styled"
import Aboutbg from "../../images/videobg.jpg"
import AbstractBg from "../../images/black-grid-cropped.jpg"

export const MainContainer = styled.div`
  display: flex;

  @media (max-width: 1118px) {
    flex-direction: column;
    height: auto;
  }
`

export const LeftContainer = styled.div`
  background-image: url(${Aboutbg});
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  background: #6a67ea;
  background-image: linear-gradient(90deg, #4f3ec8 0%, #8957f6 100%);
  background: #000;
  width: 50%;
  padding-top: 120px;
  @media (max-width: 1118px) {
    width: 100%;
    height: 600px;
  }
  @media (max-width: 560px) {
    width: 100%;
    height: 367px;
  }
`

export const RightContainer = styled.div`
  width: 100%;
  padding-top: 120px;
  padding-bottom: 120px;
  background: #000;
  background-size: cover;
  background-position-x: -166px;
  @media (max-width: 1118px) {
    width: 100%;
    padding-bottom: 50px;
  }

  @media (max-width: 560px) {
    padding-top: 50px;
    margin-top: 10px;
  }
`
export const RightInnerContainer = styled.div`
  width: 75%;
  margin: auto;
  @media (max-width: 560px) {
    width: 80%;
    padding-bottom: 50px;
  }
`

export const AboutHeading = styled.div`
  font-weight: 700;
  font-family: Poppins, sans-serif;
  font-size: 50px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  line-height: 2rem;

  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 500px) {
    font-size: 36px;
    line-height: 44px;
    text-align: left;
  }
  @media (max-width: 340px) {
  }
`

export const AboutSubheading = styled.div`
  font-weight: 400;
  font-size: 16px;
  font-family: Poppins;
  color: #ffffff;
  margin-top: 30px;
  text-align: justify;

  @media (max-width: 560px) {
    font-size: 14px;
  }
`

export const PlayButton = styled.div`
  position: absolute;
  border: 59px solid rgba(255, 255, 255, 0.06);
  content: "";
  border-radius: 50%;
  left: -31px;
  top: -31px;
  right: 0;
  z-index: 0;
`
